/*=========================================================================================
  File Name: globalComponents.js
  Description: Here you can register components globally
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import VxTooltip from './layouts/components/vx-tooltip/VxTooltip.vue'
import VxCard  from './components/vx-card/VxCard.vue'
import VxList  from './components/vx-list/VxList.vue'
import VxBreadcrumb  from './layouts/components/VxBreadcrumb.vue'
import FeatherIcon  from './components/FeatherIcon.vue'
import VxInputGroup  from './components/vx-input-group/VxInputGroup.vue'
import FormActionButton from '@/components/FormActionButton'
import DateInput from '@/components/input/DateInput'
import SelectStatus from '@/components/select/SelectStatus'
import SelectCategory from '@/components/select/SelectCategory'
import SelectCategoryParent from '@/components/select/SelectCategoryParent'
import SelectBillingCycle from '@/components/select/SelectBillingCycle'
import SelectMember from '@/components/select/SelectMember'
import SelectListing from '@/components/select/SelectListing'
import SelectMarketing from '@/components/select/SelectMarketing'
import SelectUserRoles from '@/components/checkbox/SelectUserRoles'
import flatPickr from 'vue-flatpickr-component';
import ContactInput from '@/components/input/ContactInput'
import StatusChip from '@/components/chip/StatusChip'
import UploadImage from '@/components/upload/UploadImage'
import UploadImageIcon from '@/components/upload/UploadImageIcon'
import Quil from '@/components/Editor/Quil'
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import 'flatpickr/dist/flatpickr.css';
import SelectBusiness from '@/components/select/SelectBusiness'
import TagsInput from "./components/input/TagsInput";

Vue.component(VxTooltip.name, VxTooltip)
Vue.component(VxCard.name, VxCard)
Vue.component(VxList.name, VxList)
Vue.component(VxBreadcrumb.name, VxBreadcrumb)
Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component(VxInputGroup.name, VxInputGroup)
Vue.component('VuePerfectScrollbar', VuePerfectScrollbar)
Vue.component('form-action-button', FormActionButton)
Vue.component('flat-pickr', flatPickr)
Vue.component('date-input', DateInput)
Vue.component('select-category', SelectCategory)
Vue.component('select-category-parent', SelectCategoryParent)
Vue.component('select-user-roles', SelectUserRoles)
Vue.component('select-status', SelectStatus)
Vue.component('select-billing-cycle', SelectBillingCycle)
Vue.component('select-member', SelectMember)
Vue.component('select-listing', SelectListing)
Vue.component('select-marketing', SelectMarketing)
Vue.component('contact-input', ContactInput)
Vue.component('upload-image', UploadImage)
Vue.component('upload-image-icon', UploadImageIcon)
Vue.component('status-chip', StatusChip)
Vue.component('quil', Quil)
Vue.component('select-business', SelectBusiness)
Vue.component('tags-input', TagsInput)

// v-select component
import vSelect from 'vue-select'

// Set the components prop default to return our fresh components
vSelect.props.components.default = () => ({
  Deselect: {
    render: createElement => createElement('feather-icon', {
      props: {
        icon: 'XIcon',
        svgClasses: 'w-4 h-4 mt-1'
      }
    }),
  },
  OpenIndicator: {
    render: createElement => createElement('feather-icon', {
      props: {
        icon: 'ChevronDownIcon',
        svgClasses: 'w-5 h-5'
      }
    }),
  },
});

Vue.component(vSelect)
